var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadiconlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M17.4999 9.16668C17.4999 8.70644 17.873 8.33334 18.3333 8.33334C18.7935 8.33334 19.1666 8.70644 19.1666 9.16668L19.1666 17.0797C19.1666 18.2325 18.234 19.1667 17.0805 19.1667L2.91929 19.1667C1.76691 19.1667 0.833252 18.2326 0.833252 17.0797L0.833252 9.16668C0.833252 8.70644 1.20635 8.33334 1.66659 8.33334C2.12682 8.33334 2.49992 8.70644 2.49992 9.16668L2.49992 17.0797C2.49992 17.3123 2.68754 17.5 2.91929 17.5L17.0805 17.5C17.3129 17.5 17.4999 17.3127 17.4999 17.0797L17.4999 9.16668ZM10.8333 3.67852L10.8333 12.9203C10.8333 13.3785 10.4634 13.75 9.99992 13.75C9.53968 13.75 9.16658 13.3751 9.16658 12.9203L9.16658 3.67852L6.00584 6.83927C5.6804 7.1647 5.15277 7.1647 4.82733 6.83927C4.50189 6.51383 4.50189 5.98619 4.82733 5.66075L9.41066 1.07742C9.7361 0.751984 10.2637 0.751984 10.5892 1.07742L15.1725 5.66075C15.4979 5.98619 15.4979 6.51383 15.1725 6.83927C14.8471 7.1647 14.3194 7.1647 13.994 6.83927L10.8333 3.67852Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadiconlight);
export default __webpack_public_path__ + "static/media/uploadiconlight.3639753ed47c2db9b73141b746c52ee1.svg";
export { ForwardRef as ReactComponent };